import { useState, useEffect, useContext } from 'react'
import { useSelector } from "react-redux"
import { Auth } from 'aws-amplify'

import store from 'redux/store';
import { setLoggedInUser } from 'redux/actions';
import { getLoggedInUser } from "redux/selectors"
import { history } from 'services/history.js'
import { showLoading } from 'services/util'
import { ThemeContext } from 'ThemeContext'
import { emailRegex } from "authentication/validators"

import { updateAuctionUser } from '../api'
import css from './sass/signup.module.scss'
import themeCss from '../components/sass/theme.module.scss'
import { getAuctionUser } from '../redux/selectors'

// this should mostly only be used by non-CRM users
// but a CRM user logging in via phone who has no primary email would land here
export default function AuctionsProfileUpdate() {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [emailAddress, setEmailAddress] = useState('')
  const [emailVerified, setEmailVerified] = useState(false)
  const [emailInVerification, setEmailInVerification] = useState()
  const [mobileNumber, setMobileNumber] = useState('')
  const [verificationCode, setVerificationCode] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  const loggedInUser = useSelector(getLoggedInUser)
  const theme = useContext(ThemeContext)
  const auctionUser = useSelector(getAuctionUser);

  const title = document.location.href.indexOf('/flow/auction') > -1 ? 'PLEASE SUPPLY US WITH SOME INFORMATION' : 'UPDATE YOUR INFORMATION'

  useEffect(() => {
    if (!loggedInUser?.cognitoUser) // login process hasn't completed yet
      return

    const login = loggedInUser.cognitoUser.signInUserSession.idToken.payload.cognitoLogin
    const attributes = loggedInUser.cognitoUser.attributes

    if (loggedInUser?.crmUser?.profile?.primaryName) {
      setFirstName(loggedInUser.crmUser.profile.primaryName.firstName)
      setLastName(loggedInUser.crmUser.profile.primaryName.keyName)
    }

    // if user is not in CRM
    if (!loggedInUser?.crmUser) {
      setFirstName(auctionUser.FirstName)
      setLastName(auctionUser.LastName)
    }

    // user has logged in using email
    if (login.indexOf('@') > 0) {
      setEmailAddress(login)
      setEmailVerified(true)
    }
    // user has logged in using mobile
    else {
      // add mobile number to user account since it's verified
      if (login.indexOf('+') === 0 && attributes.phone_number_verified === true) {
        setMobileNumber(login)
      }

      // user has already set ContactEmail
      if (auctionUser.ContactEmail) {
        setEmailAddress(auctionUser.ContactEmail)
        setEmailVerified(true)
      }
      // if mobile user has already verified email in Cognito (this is the first app to do so), don't make them verify again
      else if (attributes.email && attributes.email_verified === true) { // important to check for true, I've seen the string "false" before
        setEmailAddress(attributes.email)
        setEmailVerified(true)
      }
      else if (loggedInUser?.crmUser?.profile?.primaryEmail) {
        setEmailAddress(loggedInUser?.crmUser?.profile?.primaryEmail)
        setEmailVerified(true)
      }
    }
 }, [loggedInUser, auctionUser.FirstName, auctionUser.LastName, auctionUser.ContactEmail])

  const submitUpdateUser = async (e) => {
    e.preventDefault()
    console.log("submitUpdateUser called")

    showLoading(true)
    setErrorMessage('')

    // US address example
    // const address = {
    //   Street1: "123 Bruin St.",
    //   Street2: "Apt 2",
    //   City: "City",
    //   State: "State",
    //   PostCode: "Zip code",
    //   Country: "Country",
    // }

    // International address example
    // const address = {
    //   Street1: "123 High St.",
    //   Street2: "Apt 2",
    //   City: "Seoul, Jongno-gu, Seoul 30174", // combine City, Province and Postal Code in the AddressCity field
    //   Country: "South Korea",
    // }

    const userFields = {
      firstName,
      lastName,
      emailAddress,
      phoneNumber: mobileNumber,
      // address,
    }
    try {
      const response = await updateAuctionUser(userFields)

      // to update user initials in nav
      const newCognitoUser = {...loggedInUser.cognitoUser, nonCrmFirstName: firstName, nonCrmLastName: lastName}
      store.dispatch(setLoggedInUser({cognitoUser:newCognitoUser, crmUser: loggedInUser.crmUser}))

      console.log(response)
      showLoading(false)
      //reroute to add payment page on successful update
      if (!auctionUser.PaymentMethods || auctionUser.PaymentMethods.length === 0) {
        //reroute to add payment page on successful update
        history.push('/flow/auction/paymentadd')
      }
      else {
        setSuccessMessage('Your information has been updated successfully.')
      }
    }
    catch(e) {
      setErrorMessage('There was an error updating your contact information, please try again or contact support at ' + theme.supportEmail + '.')
      showLoading(false)
    }
  }

  const startVerify = async (e) => {
    e.preventDefault()

    console.log("startVerify!!!")

    setErrorMessage('')

    if (!emailRegex.test(emailAddress)) {
      setErrorMessage('Invalid email address.')
      return
    }

    showLoading(true)

    try {
      const user = await Auth.currentAuthenticatedUser()

      // prevent multiple texts
      if (user.attributes.email === emailAddress && user.attributes.email_verified === false) {
        const verifyCurrentUserAttributeResponse = await Auth.verifyCurrentUserAttribute("email")
        console.log({verifyCurrentUserAttributeResponse})
      }
      else {
        // verification is sent automatically when updating email
        const updateUserAttributesResponse = await Auth.updateUserAttributes(user, { email: emailAddress })
        console.log({updateUserAttributesResponse})
      }

      setEmailInVerification(true)
    }
    catch (e) {
      setErrorMessage(e.message || 'Error in validation. Please try again.')
    }
    showLoading(false)
  }

  const submitVerifyCode = async (e) => {
    e.preventDefault()

    showLoading(true)

    try {
      const verifyCurrentUserAttributeSubmitResponse = await Auth.verifyCurrentUserAttributeSubmit("email", verificationCode)
      console.log({verifyCurrentUserAttributeSubmitResponse})
      setEmailVerified(true)
    }
    catch (e) {
      console.log(e)
      setErrorMessage(e.message)
    }

    showLoading(false)
  }

  const changeContactEmail = async (e) => {
    e.preventDefault()

    setEmailInVerification(false)
    setEmailVerified(false)
  }

  return (
    <>
      <form onSubmit={submitUpdateUser}>
        <div className={css['signup-form']}>
          <div className={css['your-information']}>
            <h2 id="landingPageTitle">{title}</h2>
            <hr />

            <div className={css['input-item']}>
              <label>First Name</label>
              <input type='text'
                     id="auctionsProfileFirstNameInput"
                     value={firstName}
                     onChange={(e) => setFirstName(e.target.value)}/>
            </div>

            <div className={css['input-item']}>
              <label>Last Name</label>
              <input type='text'
                     id="auctionsProfileLastNameInput"
                     value={lastName}
                     onChange={(e) => setLastName(e.target.value)}/>
            </div>

            <div className={css['input-item']}>

              {/* no need to show email address for non phone users */}
              {mobileNumber &&
                <>
                  <label>Email Address</label>
                  <input type='text'
                         id="auctionsProfileEmailInput"
                         required
                         disabled={emailVerified}
                         value={emailAddress}
                         onChange={(e) => setEmailAddress(e.target.value)}/>
                </>}

              {/* only let phone login users update their email */}
              {emailAddress && emailVerified && mobileNumber &&
                <span>
                  <button type="button"
                          id="changeContactEmailButton"
                          onClick={changeContactEmail}
                          className={`${themeCss['button']} ${themeCss['FilledBlue']}`}
                    >Change Contact Email</button>
                </span>}

              {emailAddress && !emailVerified &&
                <span>

                  {!emailInVerification &&
                    <button type="button"
                            id="verifyEmailButton"
                            onClick={(e) => startVerify(e)}
                            className={`${themeCss['button']} ${themeCss['FilledBlue']}`}
                      >Verify Email Address</button>}

                  {emailInVerification &&
                    <>
                      <button type="submit"
                              id="submitEmailVerificationCodeButton"
                              onClick={submitVerifyCode}
                              className={`${themeCss['button']} ${themeCss['FilledBlue']}`}
                        >Submit Verification Code</button>

                      <input type="text"
                             id="emailVerificationCodeInput"
                             onChange={e => setVerificationCode(e.target.value)}
                             value={verificationCode}/>
                    </>}

                </span>}
            </div>

            <div className={css['signup-form-button-container']}>
              <button type="submit"
                      id="completeSignUpButton"
                      onClick={submitUpdateUser}
                      disabled={!firstName || !lastName || !emailVerified}
                      className={`${themeCss['button']} ${themeCss['FilledBlue']}`}
                >Update Account</button>
            </div>

            {/* <div className={css['signup-form-button-container']}>
              <button
                      onClick ={(e) => {history.push({ pathname: '/user/paymentupdate' })}}
                      className={`${themeCss['button']} ${themeCss['FilledBlue']}`}
                >Add / Update Credit Card</button>
            </div> */}

            {successMessage && <div className={css['update-user-success']}>
              <b>{successMessage}</b>
            </div>}

            {errorMessage && <div className={css['update-user-error']}>
              <b>{errorMessage}</b>
            </div>}

          </div>
        </div>
      </form>
    </>
  )
}